import { render } from "./riskApp.vue?vue&type=template&id=8b001a08&scoped=true"
import script from "./riskApp.vue?vue&type=script&lang=js"
export * from "./riskApp.vue?vue&type=script&lang=js"

import "./riskApp.vue?vue&type=style&index=0&id=8b001a08&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b001a08"]])

export default __exports__